import React from 'react'

export default function VerifiedV2(props) {
  return (
    <svg width={props.width ? props.width : '80'}
         height={props.height ? props.height : '80'}
         className={props.className ? props.className : ''}
         viewBox='0 0 80 80'
         fill='none'
         xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='40' cy='40' r='40' fill='#1D79FB' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M30.5049 43.1492C32.0679 44.7061 34.5963 44.7037 36.1563 43.1437L52.9333 26.3667C54.239 25.061 56.3572 25.0647 57.6583 26.375C58.9529 27.6788 58.9492 29.7841 57.65 31.0833L36.1618 52.5716C34.5997 54.1337 32.067 54.1337 30.5049 52.5716L22.3523 44.4189C21.0531 43.1198 21.0531 41.0135 22.3523 39.7144C23.6496 38.417 25.7524 38.415 27.0523 39.7099L30.5049 43.1492Z'
        fill='white'
      />
    </svg>
  )
}
